import { obterParametrosDaURL } from "../../../../functions";
import { apiAssinaturaDigital } from "../../api";
import { ApiException } from "../../api-exception";
import { IResumoOrcamentoRequest } from "./VerificarSolicitacaoRespondida";

export interface IItemResumoOrcamento {
  quantidade: number;
  unidade: string;
  descricao: string;
  valorBruto: number;
  valorLiquido: number;
  desconto: number;
}

export interface INegociacaoResumoOrcamento {
  nrParcela: number;
  valor: number;
}

export interface IComplementoOrcamento {
  chave: string;
  valor: string;
}

export interface IResumoOrcamento {
  totalBruto: number;
  desconto: number;
  totalLiquido: number;
  pedido: number;
  data: string;
  cliente: string;
  cpfcnpj: string;
  endereco: string;
  cidadeUF: string;
  condicaoPagamento: string;
  fone: string;
  rG_IE: string;
  bairro: string;
  vendedor: string;
  itens: IItemResumoOrcamento[];
  negociacao: INegociacaoResumoOrcamento[];
  complementos: IComplementoOrcamento[];
  tipoEntrega: string;
  numEndereco: string | null;
}

export const ObterResumoOrcamento = async ({
  NumOrc,
  CodLoja,
}: IResumoOrcamentoRequest): Promise<IResumoOrcamento> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await apiAssinaturaDigital.get<IResumoOrcamento>(
      `/Orcamento/resumoorcamento`,
      {
        params: { NumOrc, CodLoja },
        headers: { token },
      }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível obter o resumo do orçamento"
    );
  }
};